module.exports = __webpack_public_path__ + "media/images/icon-time-e3ac547079599b86024273b9129c89a1.png";